import React from "react";
import BackgroundLayer from "./Components/BackgroundLayer";
import FrontLayer from "./Components/FrontLayer";

export default function Home() {
  return (
    <>
      <BackgroundLayer />
      <FrontLayer />
    </>
  );
}
